var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nuttrema-abc-button"},[_c('el-button',{attrs:{"type":_vm.type,"size":"mini"},on:{"click":_vm.toggleState}},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f24745","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/panels/nuttrema-abc-button.vue
// module id = 3150
// module chunks = 0